export default __webpack_public_path__ + "static/media/Slide46.88972bf7.PNG";